import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categoryContent } from '@/mocks/categoryData';
import { categories as allCategories } from '@/mocks/homeData';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug && categoryContent[slug] ? categoryContent[slug] : categoryContent['drama'];
  const categoryMeta = allCategories.find((c) => c.slug === (slug || 'drama'));
  const actualSlug = slug && categoryContent[slug] ? slug : 'drama';

  return (
    <>
      <Navbar />
      <main>
        <div className="pt-16 md:pt-18 bg-background-50">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />

          <section className="py-6 md:py-10">
            <div className="container-custom">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-500 text-white rounded-xl">
                  <i className={`${category.icon} text-xl md:text-2xl`}></i>
                </div>
                <div>
                  <h1 className="font-serif text-2xl md:text-3xl font-bold text-foreground-900">
                    {category.name}在线观看
                  </h1>
                  <p className="text-sm text-foreground-500 mt-1">
                    {category.description}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
                {allCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                      actualSlug === cat.slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                    }`}
                  >
                    <i className={`${cat.icon} text-sm`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {category.items.map((item) => (
                  <div
                    key={item.id}
                    className="group bg-white rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
                  >
                    <div className="aspect-[2/3] overflow-hidden relative">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                        title={`${item.title} - 日本在线观看 ${category.name}`}
                      />
                      <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/70 text-white px-1.5 py-0.5 rounded-md">
                        <i className="ri-star-fill text-yellow-400 text-xs"></i>
                        <span className="text-xs font-medium">{item.rating}</span>
                      </div>
                    </div>
                    <div className="p-3 md:p-4">
                      <h3 className="font-serif font-semibold text-foreground-900 text-sm md:text-base mb-1 line-clamp-1">
                        {item.title}
                      </h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                        {item.description}
                      </p>
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-xs text-foreground-400">{item.year}</span>
                        {item.tags.slice(0, 2).map((tag) => (
                          <span
                            key={tag}
                            className="text-xs px-1.5 py-0.5 bg-background-100 text-foreground-500 rounded"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}